<!-- #################################################################################### -->
<!-- ###### HERINCOHAN                                                             ###### -->
<!-- ###### @author: Diego Alexander Villalba Cely                                 ###### -->
<!-- ###### @date: Octubre 2023                                                    ###### -->
<!-- #################################################################################### -->

<!-- #################################################################################### -->
<!-- ###### Sección de HTML                                                        ###### -->
<!-- #################################################################################### -->
<template>
  <div class="body-PB">
    <iframe title="Notas crédito" width="100%" height="100%"
      src="https://app.powerbi.com/view?r=eyJrIjoiNTZhMWFjZGUtYjcwOC00ZjZmLWJkNDItNjRmYmYzZTNlYzE3IiwidCI6IjllMDQ0ZjE3LWM3M2MtNGU1ZC04NWViLTMyNDNlNTU1YjczOSIsImMiOjR9&pageName=ReportSection"
      frameborder="0" allowFullScreen="true"></iframe>
  </div>
</template>
        
        <!-- #################################################################################### -->
        <!-- ###### Sección de Scripts                                                     ###### -->
        <!-- #################################################################################### -->
<script>
export default {
  name: 'NotasCredito',
}
</script>
        
        <!-- #################################################################################### -->
        <!-- ###### Sección de styles                                                      ###### -->
        <!-- #################################################################################### -->
<style scoped>
.body-PB {
  height: 93% !important;
}
</style>